@if (state$ | async; as parentState) {
  <div
    class="heading" [attr.aria-label]="facet.name" role="button" [attr.aria-expanded]="state.opened"
    [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-heading'"
  >
    <button
      [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-toggle-btn'"
      class="heading--button btn btn-wide"
      (click)="toggle($event)"
      [attr.aria-label]="(state.opened ? 'dpCommon.collapse' : 'dpCommon.expand') | cxTranslate"
    >
      <span
        class="text" [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-name'"
      >{{ facet.name }}</span>
      <mat-icon class="caret" svgIcon="arrow-down"></mat-icon>
    </button>
  </div>
  @if (state.opened) {
    <div
      class="content" @fadeInContentByHeightOpacity
      [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-body'"
    >
      <ng-container [formGroup]="form">
        <mat-slider
          [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-slider'"
          [min]="form.disabled ? range.from - range.step: range.from"
          [max]="form.disabled ? range.to + range.step : range.to"
          [step]="range.step"
          [disableRipple]="true"
        >
          <input
            formControlName="from" matSliderStartThumb
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-slider-input'"
          >
          <input
            formControlName="to" matSliderEndThumb
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-slider-input'"
          >
        </mat-slider>
      </ng-container>

      <div class="facet-range-filter" [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-range-filter'">
        <label class="facet-range-filter--label body-medium">
          {{ 'productList.filters.from' | cxTranslate }} ({{ range.from }})
          <input
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-range-filter-from'"
            [disabled]="form.disabled"
            class="form-control" [attr.aria-label]="'productList.filters.from' | cxTranslate" type="number"
            [min]="range.from" [max]="range.to" placeholder="From" [ngModel]="form.from.value"
            (ngModelChange)="form.from.setValue($event)" [ngModelOptions]="{standalone:true}"
          />
        </label>
        <label class="facet-range-filter--label body-medium">
          {{ 'productList.filters.to' | cxTranslate }} ({{ range.to }})
          <input
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-range-filter-to'"
            [disabled]="form.disabled"
            class="form-control" [attr.aria-label]="'productList.filters.to' | cxTranslate" type="number"
            [min]="range.from"
            [max]="range.to" placeholder="To" [ngModel]="form.to.value"
            (ngModelChange)="form.to.setValue($event)" [ngModelOptions]="{standalone:true}"
          />
        </label>
        <button
          [disabled]="!(rangedFacetValues$ | async).length"
          class="btn btn-secondary" (click)="onApplyRange()"
          [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-range-filter-apply-btn'"
        >{{ 'cartDetails.apply' | cxTranslate }}
        </button>
      </div>
      @for (value of rangedFacetValues$ | async | slice: 0 : 6; track value.name) {
        <a
          [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-' + value.name"
          #facetValue
          [routerLink]="route"
          class="value body-medium"
          [queryParams]="getLinkParams(value)"
          [class.selected]="value.selected"
          (keydown.space)="openLink($event)"
          [cxFocus]="{ key: value.name }"
        >
          <input
            type="checkbox" [name]="value.name" [checked]="value.selected" readonly
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-' + value.name + '-checkbox'"
          >
          <span
            class="label" [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-' + value.name + '-label'"
          >{{ value.name }} ({{ value.count }})</span>
        </a>
      }

      <div class="more">
        @for (value of rangedFacetValues$ | async | slice: 6 : parentState.maxVisible; track value.name) {
          <a
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-' + value.name"
            #facetValue
            class="value body-medium"
            [routerLink]="route"
            [queryParams]="getLinkParams(value)"
            [cxFocus]="{ key: value.name }"
            (keydown.space)="openLink($event)"
          >
            <input
              type="checkbox" [name]="value.name" [checked]="value.selected" readonly
              [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-' + value.name + '-checkbox'"
            >
            <span
              class="label"
              [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-' + value.name + '-label'"
            >{{ value.name }} ({{ value.count }})</span>
          </a>
        }

        @if (getExpandButtonVisibility((rangedFacetValues$ | async)?.length, 6)) {
          <button
            [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-show-more-btn'"
            class="btn btn-secondary"
            cxFocus="moreorless"
            (click)="toggleExpandFacetValuesView()"
            [attr.aria-label]="(visibleValues ? 'productList.showLess' : 'productList.showMore') | cxTranslate"
          >
            <span [attr.data-test]="'facet-list-panel--item-' + facet.facetCode + '-show-more-label'">
              {{ (visibleValues ? 'productList.showLess' : 'productList.showMore') | cxTranslate }}
            </span>
          </button>
        }
      </div>
    </div>
  }
}
